import React, { useState } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useLanguage } from '@/contexts/LanguageContext';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const FAQSection = () => {
  const { t } = useTranslation();
  const { direction } = useLanguage();
  const [openItem, setOpenItem] = useState<number | null>(null);

  const toggleItem = (id: number) => {
    setOpenItem(openItem === id ? null : id);
  };

  const faqItems: FAQItem[] = [
    {
      id: 1,
      question: t('faqQuestion1'),
      answer: t('faqAnswer1'),
    },
    {
      id: 2,
      question: t('faqQuestion2'),
      answer: t('faqAnswer2'),
    },
    {
      id: 3,
      question: t('faqQuestion3'),
      answer: t('faqAnswer3'),
    },
    {
      id: 4,
      question: t('faqQuestion4'),
      answer: t('faqAnswer4'),
    },
    {
      id: 5,
      question: t('faqQuestion5'),
      answer: t('faqAnswer5'),
    },
  ];

  return (
    <section id="faq" className="py-20 bg-synagogue-light">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-synagogue-blue">
            {t('faqTitle')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('faqSubtitle')}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqItems.map((item) => (
            <div 
              key={item.id} 
              className="mb-4 bg-white rounded-lg shadow-md overflow-hidden"
            >
              <button
                className={`w-full p-4 flex items-center justify-between text-left bg-white hover:bg-synagogue-light transition-colors ${
                  direction === 'rtl' ? 'text-right' : 'text-left'
                }`}
                onClick={() => toggleItem(item.id)}
                aria-expanded={openItem === item.id}
              >
                <span className="text-lg font-semibold text-synagogue-blue">
                  {item.question}
                </span>
                <svg
                  className={`w-5 h-5 text-synagogue-blue transition-transform ${
                    openItem === item.id ? 'transform rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={openItem === item.id ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'}
                  />
                </svg>
              </button>
              
              {openItem === item.id && (
                <div 
                  className="p-4 border-t border-gray-200 bg-white"
                  dir={direction}
                >
                  <p className="text-gray-600">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            {t('faqContactText')}
          </p>
          <a
            href="mailto:support@digital-synagogue.com"
            className="inline-block bg-synagogue-blue hover:bg-synagogue-gold text-white font-semibold py-2 px-6 rounded-lg transition-colors"
          >
            {t('faqContactButton')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection; 